import React from "react";
import { Button, IconButton, Snackbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CustomAlert } from "./styled/Container.styled";
import {
  TOP_CENTER_SNACKBAR_MAX_WIDTH,
  TOP_CENTER_SNACKBAR_WIDTH,
} from "../constants/Defaults.constants";

const ActionSnackbar = ({
  severity = "success",
  borderColor = "transparent",
  vertical = "bottom",
  horizontal = "left",
  width = "inherit",
  isOpen = false,
  closeFn = () => {},
  snackbarLabel = "",
  hasAction = true,
  actionLabel = "",
  actionFn = () => {},
  autoHideDuration = null,
}) => {
  const isTopCenter = vertical === "top" && horizontal === "center";
  const snackbarWidth =
    isTopCenter && (width === "inherit" || width == null)
      ? TOP_CENTER_SNACKBAR_WIDTH
      : width;

  const actionButton = hasAction ? (
    <Button color="primary" onClick={actionFn}>
      {actionLabel}
    </Button>
  ) : (
    <IconButton onClick={closeFn}>
      <CloseIcon />
    </IconButton>
  );
  return (
    <Snackbar
      open={isOpen}
      onClose={closeFn}
      anchorOrigin={{ vertical, horizontal }}
      autoHideDuration={autoHideDuration}
      sx={{
        width: snackbarWidth,
        ...(isTopCenter && {
          maxWidth: TOP_CENTER_SNACKBAR_MAX_WIDTH,
        }),
      }}
    >
      <CustomAlert
        onClose={closeFn}
        severity={severity}
        action={actionButton}
        sx={{
          width: "100%",
          maxWidth: isTopCenter ? TOP_CENTER_SNACKBAR_MAX_WIDTH : "100%",
          boxSizing: "border-box",
          border: "1px solid",
          borderColor: borderColor,
          "& .MuiAlert-message": {
            overflowWrap: "anywhere",
          },
        }}
      >
        {snackbarLabel}
      </CustomAlert>
    </Snackbar>
  );
};

export default ActionSnackbar;
